export default "__VITE_ASSET__6b0ac0a7__"